export default {
  props: {
    count: {
      required: true,
    },
    perPage: {
      default: 10,
      required: false,
    },
  },
  created: function () {
    this.$store.registerModule('pagination', {
      state: {
        page: 1,
      },
      mutations: {
        [`pagination/PAGINATE`] (state, page) {
          state.page = page
        },
      },
    })
  },
  methods: {
    currentPage (page) {
      return page === this.page
    },
    setPage (page) {
      this.$store.commit('pagination/PAGINATE', page)
    },
    incrementPage () {
      if (!this.isLastPage) {
        this.setPage(this.page + 1)
      }
    },
    decrementPage () {
      if (!this.isFirstPage) {
        this.setPage(this.page - 1)
      }
    },
  },
  computed: {
    page () {
      return this.$store.state['pagination'].page
    },
    isFirstPage () {
      return this.page === 1
    },
    isLastPage () {
      return this.page === this.totalPages
    },
    showBeforeLastPage () {
      if (this.totalPages < 7) {
        return -1
      }

      return this.totalPages - 5
    },
    totalPages () {
      return Math.ceil(this.count / this.perPage)
    },
    pagesToShow () {
      var pages = []
      var startPage, endPage
      var minPage = 3
      var maxPage = this.totalPages - 2

      if (this.page < minPage + 2) {
        startPage = minPage
        endPage = Math.min(maxPage, startPage + 2)
      } else if (this.page > maxPage - 2) {
        endPage = maxPage
        startPage = endPage - 2
      } else {
        startPage = this.page - 1
        endPage = this.page + 1
      }

      startPage = Math.max(3, startPage)

      for (var i = startPage; i <= endPage; i++) {
        pages.push(i)
      }

      return pages
    },
  },
}
